import Navbar from "@/components/feature/Navbar";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Footer from "../../../components/feature/Footer";

import {
  BaseUrl,
  Unichat_Url,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../../Services/Urls";
import {
  makeApiRequest,
  callApi,
  makeApiRequest_seperateDb,
  makeApiRequest_seperateDb_get,
} from "../../../Services/ApiService";
import { TailSpin } from "react-loader-spinner";

import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
  uploadFile,
} from "../../../Services/ApiCall";

import {
  decryptOtp,
  getUser,
  formatDisplayDate,
} from "../../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../../Context/Context";

interface ContentItem {
  id: string;
  title: string;
  date: string;
  description: string;
  summary: string;
  image?: string;
  pdfUrl?: string;
  category: string;
  createdAt: number;
}

const categories = [
  "News Feeds",
  "Announcements",
  "Product Launches",
  "Achievements",
  "Events",
  "Press Releases",
  "Research & Innovation",
];

const AddContentPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("News Feeds");
  const [date, setDate] = useState("");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [YoutubeUrl, setYoutubeUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [existingContent, setExistingContent] = useState<ContentItem[]>([]);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [data, setdata] = useState([]);
  const [Loading, setLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState<any>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    // const savedContent = localStorage.getItem("radhey-content");
    // if (savedContent) {
    //   setExistingContent(JSON.parse(savedContent));
    // }

    getdata();

    // Set default date to today
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  const getdata = () => {
    let userdata = getUser();

    let url = `${Unichat_Url}/universaldairy/user/${userdata?.LedgerID}`;

    makeApiRequest_seperateDb(
      url,
      (response: any) => {
        if (response?.success === true) {
          setdata(response?.records);
        }
      },
      (error: any) => {},
    );
  };
  const resetForm = () => {
    setTitle("");
    setCategory("News Feeds");
    setDate(new Date().toISOString().split("T")[0]);
    setSummary("");
    setDescription("");
    setImageUrl("");
    setPdfUrl("");
    setEditingId(null);
    setShowPreview(false);
  };

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handleSubmit = () => {
    if (!title || !category || !date || !summary || !description) {
      alert("Please fill in all required fields.");
      return;
    }

    let userdata = getUser();

    setIsSubmitting(true);

    const url = `${Unichat_Url}/universaldairy/create`;
    const body = {
      Title: title,
      Category: category,
      Date: date,
      Summary: summary,
      Description: description,
      Images: imageUrl,
      Docs: pdfUrl,
      Url: YoutubeUrl,
      UserName: userdata?.LedgerName,
      UserID: userdata?.LedgerID,
    };

    callApi(
      url,
      body,
      "",
      (response: any) => {
        if (response?.success === true && response != null) {
          alert(response?.message ?? "Content added successfully.");
          setIsSubmitting(false);
          resetForm();
          getdata();
        } else {
          setIsSubmitting(false);
          alert(
            response?.message ?? "Failed to add content. Please try again.",
          );
        }
      },
      (error: any) => {},
    );
  };

  const handleEdit = (item: any) => {
    const url = `${Unichat_Url}/universaldairy/update/${item?._id}`;

    let userdata = getUser();

    // setIsSubmitting(true);

    // const url = `${BaseUrl}/biotech/create`;
    const body = {
      Title: title,
      Category: category,
      Date: date,
      Summary: summary,
      Description: description,
      Images: imageUrl,
      Docs: pdfUrl,
      Url: YoutubeUrl,
      UserName: userdata?.UserName,
      UserID: userdata?.UserID,
    };

    callApi(
      url,
      body,
      "",
      (response: any) => {
        if (response?.success === true && response != null) {
          alert(response?.message ?? "Content updated successfully.");
          getdata();
          setShowEditModal(false);
        } else {
          alert(
            response?.message ?? "Failed to delete content. Please try again.",
          );
        }
      },
      (error: any) => {},
    );
  };

  const handleDelete = (id: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this content?",
    );

    if (!confirmDelete) {
      return; // Stop if user cancels
    }

    const url = `${Unichat_Url}/universaldairy/delete/${id}`;

    callApi(
      url,
      {},
      "",
      (response: any) => {
        if (response?.success === true && response != null) {
          alert(response?.message ?? "Content deleted successfully.");
          getdata();
        } else {
          alert(
            response?.message ?? "Failed to delete content. Please try again.",
          );
        }
      },
      (error: any) => {},
    );
  };

  const handleUpload = async (e) => {
    setLoading(true);
    const urls = await uploadMultipleFiles({
      files: Array.from(e.target.files),
    });

    if (!urls.length) {
      setLoading(false);
      return;
    }

    setImageUrl([...urls].join(","));
    setLoading(false);
  };

  const handleUploaddoc = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    try {
      setLoading(true);

      const url = await uploadFile(file); // ✅ pass file directly

      if (url) {
        setPdfUrl(url);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };
  const openEditModal = (item: any) => {
    setEditingItem(item);
    setTitle(item.Title);
    setCategory(item.Category);
    setDate(item.Date);
    setSummary(item.Summary);
    setDescription(item.Description);
    setImageUrl(item.Images);
    setPdfUrl(item.Docs);
    setYoutubeUrl(item.Url);
    setShowEditModal(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative pt-20 pb-20 bg-gradient-to-br from-[#1A2B4A] to-[#00B8A9]">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-6xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Add Content
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <button
            onClick={() => navigate("/news-research")}
            className="flex items-center text-gray-600 hover:text-primary mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Media
          </button>

          {/* Form Card */}
          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              {editingId ? "Edit Content" : "Post New Content"}
            </h2>

            {/* Preview Toggle */}
            {!showPreview ? (
              <div className="space-y-6">
                {/* Title */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Title <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter content title"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm"
                  />
                </div>

                {/* Category & Date Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Category <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm cursor-pointer"
                    >
                      {categories.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm cursor-pointer"
                    />
                  </div>
                </div>

                {/* Summary */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Short Summary <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={summary}
                    onChange={(e) => setSummary(e.target.value)}
                    placeholder="Brief summary of the content (max 200 characters)"
                    rows={2}
                    maxLength={200}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm resize-none"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {summary.length}/200 characters
                  </p>
                </div>

                {/* Full Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Full Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Detailed description of the content"
                    rows={6}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm resize-none"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {description.length}/500 characters
                  </p>
                </div>

                {/* Image Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Image Upload <span className="text-red-500">*</span>
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary/50 transition-colors">
                    {imageUrl ? (
                      <div className="relative">
                        <img
                          src={imageUrl}
                          alt="Preview"
                          className="max-h-48 mx-auto rounded-lg"
                        />
                        <button
                          onClick={() => setImageUrl("")}
                          className="absolute top-2 right-2 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-red-600"
                        >
                          <i className="ri-close-line"></i>
                        </button>
                      </div>
                    ) : (
                      <label className="cursor-pointer">
                        <i className="ri-image-add-line text-4xl text-gray-400 mb-2"></i>
                        <p className="text-sm text-gray-500">
                          Click to upload image
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          PNG, JPG up to 5MB
                        </p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleUpload}
                          className="hidden"
                        />
                      </label>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Youtube Url
                  </label>
                  <input
                    type="text"
                    value={YoutubeUrl}
                    onChange={(e) => setYoutubeUrl(e.target.value)}
                    placeholder="Enter Youtube Video Url (Optional)"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm"
                  />
                </div>

                {/* PDF Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    PDF / Document Upload (Optional)
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary/50 transition-colors">
                    {pdfUrl ? (
                      <div className="flex items-center justify-center gap-4">
                        <i className="ri-file-pdf-line text-3xl text-red-500"></i>
                        <span className="text-sm text-gray-600">
                          Document uploaded
                        </span>
                        <button
                          onClick={() => setPdfUrl("")}
                          className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-red-600"
                        >
                          <i className="ri-close-line"></i>
                        </button>
                      </div>
                    ) : (
                      <label className="cursor-pointer">
                        <i className="ri-file-pdf-line text-4xl text-gray-400 mb-2"></i>
                        <p className="text-sm text-gray-500">
                          Click to upload PDF
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          PDF up to 10MB
                        </p>
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={handleUploaddoc}
                          className="hidden"
                        />
                      </label>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <button
                    onClick={() => setShowPreview(true)}
                    disabled={!title || !summary || !description}
                    className="flex-1 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <i className="ri-eye-line mr-2"></i>
                    Preview
                  </button>
                  <button
                    onClick={() => handleSubmit()}
                    disabled={
                      isSubmitting ||
                      !title ||
                      !summary ||
                      !description ||
                      !imageUrl ||
                      !date ||
                      !category
                    }
                    className="flex-1 px-6 py-3 bg-[#0a7f82] text-white rounded-lg font-medium hover:bg-[#0a7f82]/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Publishing...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line mr-2"></i>
                        {editingId ? "Update" : "Publish"}
                      </>
                    )}
                  </button>
                </div>

                {editingId && (
                  <button
                    onClick={resetForm}
                    className="w-full px-6 py-3 border border-gray-300 text-gray-600 rounded-lg font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancel Editing
                  </button>
                )}
              </div>
            ) : (
              /* Preview Mode */
              <div>
                <div className="bg-gray-50 rounded-xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                      {category}
                    </span>
                    <span className="text-xs text-gray-500">
                      {date ? formatDate(date) : "No date"}
                    </span>
                  </div>
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt="Preview"
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                  )}
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    {title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">{summary}</p>
                  <p className="text-sm text-gray-700">{description}</p>
                  {pdfUrl && (
                    <div className="mt-4 flex items-center text-sm text-gray-600">
                      <i className="ri-file-pdf-line text-red-500 mr-2"></i>
                      PDF Document attached
                    </div>
                  )}
                </div>

                <div className="flex gap-4">
                  <button
                    onClick={() => setShowPreview(false)}
                    className="flex-1 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-edit-line mr-2"></i>
                    Edit
                  </button>
                  <button
                    onClick={handleSubmit}
                    disabled={
                      isSubmitting ||
                      !title ||
                      !summary ||
                      !description ||
                      !imageUrl ||
                      !date ||
                      !category
                    }
                    //   disabled={isSubmitting}
                    className="flex-1 px-6 py-3 bg-[#0a7f82] text-white rounded-lg font-medium hover:bg-primary/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Publishing...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line mr-2"></i>
                        {editingId ? "Update" : "Publish"}
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Existing Content Management */}
          {data?.length > 0 && (
            <div className="mt-12">
              <h3 className="text-xl font-bold text-gray-800 mb-6">
                Manage Existing Content
              </h3>
              <div className="space-y-4">
                {data?.map((item) => (
                  <div
                    key={item._id}
                    className="bg-white rounded-lg shadow-md border border-gray-100 p-4 flex items-center justify-between"
                  >
                    <div className="flex items-center gap-4 flex-1 min-w-0">
                      {item.Images && (
                        <img
                          src={item.Images}
                          alt={item.title}
                          className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                        />
                      )}
                      <div className="min-w-0">
                        <h4 className="font-medium text-gray-800 truncate">
                          {item.Title}
                        </h4>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full">
                            {item.Category}
                          </span>
                          <span className="text-xs text-gray-500">
                            {formatDisplayDate(item.Date || "")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0 ml-4">
                      <button
                        onClick={() => openEditModal(item)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 rounded-lg hover:bg-primary/10 hover:text-primary transition-colors cursor-pointer"
                      >
                        <i className="ri-edit-line"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 rounded-lg hover:bg-red-50 hover:text-red-500 transition-colors cursor-pointer"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              {showEditModal && (
                <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                  <div className="bg-white w-full max-w-2xl rounded-2xl p-8 shadow-xl relative max-h-[90vh] overflow-y-auto">
                    <button
                      onClick={() => setShowEditModal(false)}
                      className="absolute top-4 right-4 text-gray-400 hover:text-red-500"
                    >
                      ✕
                    </button>

                    <h3 className="text-xl font-bold mb-6">Edit Content</h3>

                    <div className="space-y-6">
                      {/* Title */}
                      <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Title"
                        className="w-full border rounded-lg px-4 py-3"
                      />

                      {/* Date */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Category <span className="text-red-500">*</span>
                          </label>
                          <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm cursor-pointer"
                          >
                            {categories.map((cat) => (
                              <option key={cat} value={cat}>
                                {cat}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Date <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 text-sm cursor-pointer"
                          />
                        </div>
                      </div>

                      {/* Summary */}
                      <textarea
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                        placeholder="Summary"
                        rows={2}
                        maxLength={200}
                        className="w-full border rounded-lg px-4 py-3 resize-none"
                      />

                      {/* Description */}
                      <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Description"
                        rows={4}
                        maxLength={500}
                        className="w-full border rounded-lg px-4 py-3 resize-none"
                      />

                      {/* Image Upload */}
                      <div>
                        <label className="block text-sm font-medium mb-2">
                          Edit Image <span className="text-red-500">*</span>
                        </label>

                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary/50 transition-colors">
                          {imageUrl ? (
                            <div className="relative">
                              <img
                                src={imageUrl}
                                alt="Preview"
                                className="max-h-40 mx-auto rounded-lg"
                              />
                              <button
                                onClick={() => setImageUrl("")}
                                className="absolute top-2 right-2 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center"
                              >
                                ✕
                              </button>
                            </div>
                          ) : (
                            <label className="cursor-pointer">
                              <p className="text-sm text-gray-500">
                                Click to upload new image
                              </p>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleUpload}
                                className="hidden"
                              />
                            </label>
                          )}
                        </div>
                      </div>

                      <input
                        type="text"
                        value={YoutubeUrl}
                        onChange={(e) => setYoutubeUrl(e.target.value)}
                        placeholder="Youtube Video Url"
                        className="w-full border rounded-lg px-4 py-3"
                      />

                      {/* PDF Upload */}
                      <div>
                        <label className="block text-sm font-medium mb-2">
                          Edit Document (PDF)
                        </label>

                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary/50 transition-colors">
                          {pdfUrl ? (
                            <div className="flex items-center justify-center gap-4">
                              <span className="text-sm text-gray-600">
                                Document Uploaded
                              </span>
                              <button
                                onClick={() => setPdfUrl("")}
                                className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center"
                              >
                                ✕
                              </button>
                            </div>
                          ) : (
                            <label className="cursor-pointer">
                              <p className="text-sm text-gray-500">
                                Click to upload new PDF
                              </p>
                              <input
                                type="file"
                                accept=".pdf"
                                onChange={handleUpload}
                                className="hidden"
                              />
                            </label>
                          )}
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="flex gap-4 pt-2">
                        <button
                          onClick={() => handleEdit(editingItem)}
                          disabled={
                            isSubmitting ||
                            !title ||
                            !summary ||
                            !description ||
                            !imageUrl ||
                            !date ||
                            !category
                          }
                          className="flex-1 bg-[#0a7f82] text-white py-3 rounded-lg"
                        >
                          {isSubmitting ? "Updating..." : "Update Content"}
                        </button>

                        <button
                          onClick={() => setShowEditModal(false)}
                          className="flex-1 border py-3 rounded-lg"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <Footer />

      {Loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </div>
  );
};

export default AddContentPage;
